import { Menu as RAMenu } from 'react-admin'

/** Explicit sidebar: scales only. Events are reached from a scale, never listed on their own. */
export const Menu = () => (
  <RAMenu>
    <RAMenu.ResourceItem name="scales" />
  </RAMenu>
)
